export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

/** Optionnel : Map ID (Cloud Console) pour activer les Advanced Markers. */
export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID ?? '';

export const GOOGLE_MAPS_LIBRARIES = ['places', 'marker'] as const;
